import Phaser from "phaser";
import WebFontFile from "./FontLoader";

export default class Game extends Phaser.Scene {

  init() {
    this.score = 0;
    this.setHeart = 3;
  }

  preload() {
    const font = new WebFontFile(this.load, "Press Start 2P");
    this.load.addFile(font);

    this.load.image('heartImg', new URL('../assets/heart.png', import.meta.url).href);
    this.load.image('brick', new URL('../assets/brick.png', import.meta.url).href);
    this.load.image('ball', new URL('../assets/ball.png', import.meta.url).href);
    this.load.image('paddle', new URL('../assets/paddle.png', import.meta.url).href);
  }

  create() {
    const width = this.scale.width;
    const height = this.scale.height;

    const angle = Phaser.Math.Between(0, 180);
    const vec = this.physics.velocityFromAngle(angle, 400);

    //creating gmae object(ball)
    this.ball = this.physics.add.image(width / 2, height / 1.5, 'ball');

    this.ball.setDisplaySize(40, 40);
    this.ball.setBounce(1, 1);
    this.ball.setVelocity(vec.x, vec.y);

    this.physics.world.pause();

    this.time.delayedCall(1000, () => {
      this.physics.world.resume()
    }, [], this)

    this.ball.setCollideWorldBounds(true);
    this.ball.body.onWorldBounds = true;

    this.createBottomLogic();

    // creating game object(paddle)
    this.paddle = this.physics.add.image(width / 2, height / 1.05, 'paddle');
    this.paddle.setDisplaySize(100, 50)
    this.paddle.body.immovable = true;
    this.physics.add.collider(this.ball, this.paddle);
    this.paddle.body.setCollideWorldBounds(true, 1, 1);

    // paddle movement
    this.cursors = this.input.keyboard.createCursorKeys();

    // score
    this.scoreText = this.add.text(width / 1.04, height / 15, "0", {
      fontSize: 25,
      fontFamily: "'Press Start 2P'",
    });


    // heart
    this.hearts = []

    for (let i = 0; i < 3; i++) {
      const widthX = this.scale.width
      const heightY = this.scale.height;

      const heart = this.physics.add.image(widthX / 50, heightY / 15 + i * 60, 'heartImg');
      heart.setDisplaySize(50, 50);
      this.hearts.push(heart);
    }

    // bricks
    const cols = 20;
    const gap = 900;

    for (let i = 0; i <= 159; i++) {
      const col = i % cols;
      const row = Math.floor(i / cols);
      const x = this.scale.width + col * (gap + 500);
      const y = this.scale.height + row * (gap);

      const brick = this.physics.add.image(x / 17, y / 13, 'brick');
      brick.setDisplaySize(70, 50)
      this.physics.add.collider(this.ball, brick, () => {
        brick.destroy();
        console.log('Boom!');

        this.score++;
        this.scoreText.setText(this.score);
      });
      brick.body.immovable = true;
    }

  }

  createBottomLogic() {
    const width = this.scale.width;
    const height = this.scale.height;
      this.physics.world.setBounds(0, 0, width, height + 100);

      this.physics.world.on('worldbounds', (body, up, down, left, right) => {
          if (body.gameObject === this.ball) {
              if (down) {
                  this.ballOut();
              }
          }
      });
  }

  ballOut() {
    this.setHeart -= 1;
    this.hearts[this.setHeart].setVisible(false);
    this.resetBall()
    // console.log('down')

    if (this.setHeart === 0) {
      this.scene.start('game-over')
    }
  }

  update() {

    const body = this.paddle.body;

    if (this.cursors.left.isDown) {
      this.paddle.x -= 10;
      body.updateFromGameObject();
    } else if (this.cursors.right.isDown) {
      this.paddle.x += 10
      body.updateFromGameObject();
    }

  }

  resetBall() {
    const width = this.scale.width;
    const height = this.scale.height;
    const angle = Phaser.Math.Between(0, 180);
    const vec = this.physics.velocityFromAngle(angle, 400);
    this.ball.setPosition(width / 2, height / 1.5);
    this.ball.setVelocity(vec.x, vec.y);
  }

}
